import { z } from 'zod';

export const getCompaniesSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
  })
);

export type GetCompaniesResponse = z.infer<typeof getCompaniesSchema>;
